import {
  FaBicycle,
  FaBinoculars,
  FaCamera,
  FaCity,
  FaGlassCheers,
  FaHiking,
  FaLandmark,
  FaMountain,
  FaPalette,
  FaRegCheckCircle,
  FaShip,
  FaShoppingBag,
  FaTicketAlt,
  FaTrain,
  FaTree,
  FaUtensils,
  FaWalking,
} from 'react-icons/fa';

// The operator names an activity as "<type> at <place>" — "Sightseeing at Latin Quarter, Paris" — so
// the icon is chosen by the type it starts with. First match wins, which is why the narrower words
// come before the broader ones.
const iconsByKeyword = [
  ['cycling', FaBicycle],
  ['bike', FaBicycle],
  ['sightseeing', FaBinoculars],
  ['photo', FaCamera],
  ['city/town tour', FaCity],
  ['city tour', FaCity],
  ['walking', FaWalking],
  ['hiking', FaHiking],
  ['nature', FaTree],
  ['eco', FaTree],
  ['mountain', FaMountain],
  ['food', FaUtensils],
  ['flavor', FaUtensils],
  ['tasting', FaGlassCheers],
  ['wine', FaGlassCheers],
  ['beer', FaGlassCheers],
  ['museum', FaLandmark],
  ['heritage', FaLandmark],
  ['cultural', FaLandmark],
  ['art', FaPalette],
  ['workshop', FaPalette],
  ['cruise', FaShip],
  ['boat', FaShip],
  ['sailing', FaShip],
  ['train', FaTrain],
  ['rail', FaTrain],
  ['shopping', FaShoppingBag],
  ['market', FaShoppingBag],
  ['ticket', FaTicketAlt],
  ['admission', FaTicketAlt],
];

const getTourActivityIcon = (activity) => {
  const name = (activity || '').toLowerCase();
  const match = iconsByKeyword.find(([keyword]) => name.indexOf(keyword) > -1);
  const icon = match ? match[1] : FaRegCheckCircle;
  return icon;
};

export default getTourActivityIcon;
